import { api } from "./api";

/* ------------------------------------------------------------------ */
/*  Types                                                             */
/* ------------------------------------------------------------------ */

/* ------------------------------------------------------------------ */
/*  Endpoints                                                         */
/* ------------------------------------------------------------------ */

export const notificationsApi = api.injectEndpoints({
  endpoints: builder => ({
    /** Get all notifications (new + hidden), newest first */
    getNotifications: builder.query({
      query: () => ({
        url: "/notifications",
        method: "GET"
      }),
      providesTags: ["Notifications"]
    }),
    /** Get only "new" notifications */
    getNewNotifications: builder.query({
      query: () => ({
        url: "/notifications/new",
        method: "GET"
      }),
      providesTags: ["Notifications"]
    }),
    /** Count of "new" notifications */
    getNotificationCount: builder.query({
      query: () => ({
        url: "/notifications/count",
        method: "GET"
      }),
      providesTags: ["Notifications"]
    }),
    /** Create a notification for the current user */
    createNotification: builder.mutation({
      query: body => ({
        url: "/notifications",
        method: "POST",
        body
      }),
      invalidatesTags: ["Notifications"]
    }),
    /** Admin: create a notification for a specific user */
    createNotificationForUser: builder.mutation({
      query: ({
        userId,
        ...body
      }) => ({
        url: `/notifications/for-user/${userId}`,
        method: "POST",
        body
      }),
      invalidatesTags: ["Notifications"]
    }),
    /** Hide a single notification */
    hideNotification: builder.mutation({
      query: id => ({
        url: `/notifications/${id}/hide`,
        method: "PATCH"
      }),
      invalidatesTags: ["Notifications"]
    }),
    /** Hide all "new" notifications */
    hideAllNotifications: builder.mutation({
      query: () => ({
        url: "/notifications/hide-all",
        method: "PATCH"
      }),
      invalidatesTags: ["Notifications"]
    })
  })
});
export const {
  useGetNotificationsQuery,
  useGetNewNotificationsQuery,
  useGetNotificationCountQuery,
  useCreateNotificationMutation,
  useCreateNotificationForUserMutation,
  useHideNotificationMutation,
  useHideAllNotificationsMutation
} = notificationsApi;